<div
  class="performance-modal-container"
  [style.background]="modalType === WebViewerPausedModalType.START ? '#EFF1F5' : '#333333B8'"
>
  <div class="performance-modal-card">
    <div class="performance-modal-text">
      <p [innerHTML]="messageText | highlighter: highlightedText"></p>
    </div>
    <button class="mat-flat-button performance-modal-button" (click)="buttonClickHandler()">
      <mat-icon class="performance-modal-button-icon">play_arrow</mat-icon>
      <div class="mr-4">
        {{ buttonText }}
      </div>
    </button>
  </div>
</div>
